import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { navigate } from 'gatsby';
import browserLocale from 'browser-locale';
import { IntlProvider } from 'react-intl';
import { useTheme } from './styled';
import messagesDe from '../src/translations/de';
import messagesEn from '../src/translations/en';
import messagesNl from '../src/translations/nl';
var messages = {
  de: messagesDe,
  en: messagesEn,
  nl: messagesNl
};
var DEFAULT_LOCALE = 'en';

var generateTitle = function generateTitle(title, siteTitle, platform, platforms) {
  return platforms[platform] && platforms[platform].title ? platforms[platform].title : title;
};

var PageWrapper = function PageWrapper(_ref) {
  var _ref$pageContext = _ref.pageContext,
      entry = _ref$pageContext.entry,
      petition = _ref$pageContext.petition,
      event = _ref$pageContext.event,
      _node = _ref$pageContext.node,
      _ref$pageContext$site = _ref$pageContext.siteMeta;
  _ref$pageContext$site = _ref$pageContext$site === void 0 ? {} : _ref$pageContext$site;
  var siteTitle = _ref$pageContext$site.siteTitle,
      children = _ref.children;
  var theme = useTheme();
  var node = entry || petition || event || _node;
  if (!node) return children;
  var title = node.title,
      _node$platforms = node.platforms,
      platforms = _node$platforms === void 0 ? {} : _node$platforms,
      _node$locale$id = node.locale.id,
      localeId = _node$locale$id === void 0 ? DEFAULT_LOCALE : _node$locale$id,
      translations = node.translations;
  var language = localeId.split('-')[0];
  useEffect(function () {
    if (typeof window !== 'undefined' && translations && translations.length > 0) {
      if (localStorage.getItem("hasLanguageRedirectRunBefore" + window.location.hostname + node.path) === null) {
        var lang = browserLocale().split('-')[0];
        var containsTranslation = false;
        var path = '';
        localStorage.setItem("hasLanguageRedirectRunBefore" + window.location.hostname + node.path, true);
        translations.forEach(function (x) {
          localStorage.setItem("hasLanguageRedirectRunBefore" + window.location.hostname + x.path, true);

          if (x.locale === lang) {
            containsTranslation = true; // eslint-disable-next-line

            path = x.path;
          }
        });

        if (containsTranslation && translations && localeId !== lang) {
          navigate(path);
        }
      }
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Helmet, {
    title: generateTitle(title, siteTitle, 'all', platforms)
  }, React.createElement("html", {
    lang: localeId || DEFAULT_LOCALE
  }), translations && translations.map(function (trans) {
    return React.createElement("link", {
      key: trans.locale,
      rel: "alternate",
      hrefLang: trans.locale,
      href: trans.path
    });
  }), React.createElement("link", {
    rel: "icon",
    type: "image/ico",
    sizes: "16x16",
    href: theme.faviconImageUrl
  }), React.createElement("meta", {
    name: "description",
    content: platforms.search.description
  }), React.createElement("meta", {
    property: "og:title",
    content: generateTitle(title, siteTitle, 'facebook', platforms)
  }), React.createElement("meta", {
    property: "og:description",
    content: platforms.facebook.description
  }), React.createElement("meta", {
    property: "fb:title",
    content: generateTitle(title, siteTitle, 'facebook', platforms)
  }), React.createElement("meta", {
    property: "fb:description",
    content: platforms.facebook.description
  }), React.createElement("meta", {
    property: "og:image",
    content: platforms.facebook.image && platforms.facebook.image.url
  }), React.createElement("meta", {
    property: "fb:image",
    content: platforms.facebook.image && platforms.facebook.image.url
  }), React.createElement("meta", {
    property: "twitter:title",
    content: generateTitle(title, siteTitle, 'twitter', platforms)
  }), React.createElement("meta", {
    property: "twitter:description",
    content: platforms.twitter.description
  }), React.createElement("meta", {
    property: "twitter:image",
    content: platforms.twitter.image && platforms.twitter.image.url
  }), React.createElement("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  })), React.createElement(IntlProvider, {
    locale: localeId,
    messages: messages[language]
  }, children));
};

export default (function (_ref2) {
  var element = _ref2.element,
      props = _ref2.props;
  return React.createElement(PageWrapper, props, element);
});